export default "__VITE_ASSET__BlxndhA6__"